import { render, staticRenderFns } from "./HealthElement.vue?vue&type=template&id=6483d002"
import script from "./HealthElement.vue?vue&type=script&lang=js"
export * from "./HealthElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports